import React, { Component } from 'react'

//Import CSS
import './inputs.css'

//Import internal components
import AppContext from '../../appContext';
import CnpjUtils from '../../shared/utils/CnpjUtils';

//Import external components
import { TextField, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";

class TrackingInputCNPJ extends Component {
    constructor(props) {
        super(props);

        TrackingInputCNPJ.contextType = AppContext;
    }

    handleChangeCnpj = (e) => {
        const formatted = CnpjUtils.formatCnpj(e.target.value);
        const syntheticEvent = {
            target: {
                name: this.props.name,
                value: formatted,
                getAttribute: (attr) => attr === "name" ? this.props.name : null,
            }
        };
        this.props.onChange(syntheticEvent);
    }

    handleChangeSelect = (e) => {
        const syntheticEvent = {
            target: {
                name: this.props.name,
                value: e.target.value,
                getAttribute: (attr) => attr === "name" ? this.props.name : null,
            }
        };
        this.props.onChange(syntheticEvent);
    }

    render() {
        let contextAux = this.context;
        const { redes } = this.props;
        return (
            <div>
                {!contextAux.userSession.redeOticas && (
                    <TextField
                        variant="outlined"
                        className="lp-field"
                        label="CNPJ da ótica buscada *"
                        name={this.props.name}
                        id={this.props.name}
                        value={CnpjUtils.formatCnpj(this.props.value)}
                        onChange={this.handleChangeCnpj}
                        disabled={this.props.disabled}
                        autoComplete="off"
                        placeholder="XX.XXX.XXX/XXXX-XX"
                        inputProps={{ maxLength: 18 }}
                    />
                )}
                {contextAux.userSession.redeOticas && (
                    <FormControl variant="outlined" className="lp-field">
                        <InputLabel id="label-cnpj">De qual ótica é seu pedido? *</InputLabel>
                        <Select
                            labelId="label-cnpj"
                            id={this.props.name}
                            name={this.props.name}
                            value={this.props.value || ""}
                            onChange={this.handleChangeSelect}
                            label="De qual ótica é seu pedido? *"
                            disabled={this.props.disabled}
                        >
                            {(redes || []).map((item) => (
                                <MenuItem key={item.value} value={item.value}>
                                    {item.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            </div>
        );
    }
}

export default TrackingInputCNPJ;
